<li class="ub-simple-list__item">
  <ng-content></ng-content>
</li>
